import {createPortal} from 'react-dom'

interface FlashMessagePortalProps {
  children: Parameters<typeof createPortal>[0]
}

const FlashMessagePortal = ({ children }: FlashMessagePortalProps) => {
  const portalRoot = document.getElementById('flash-message-portal')

  if (!portalRoot) {
    throw new Error('Portal root element not found')
  }

  return createPortal(children, portalRoot)
}

export default FlashMessagePortal
